import React from "react";
import styles from "./ToggleSwitch.module.css";

interface ToggleSwitchProps {
  label: string;
  value: boolean;
  onToggle: (checked: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, value, onToggle }) => {
  return (
    <div className={styles.toggleRow}>
      <span className={styles.toggleLabel}>{label}</span>
      <div
        className={`${styles.toggleTrack} ${value ? styles.isActive : ""}`}
        onClick={() => onToggle(!value)}
      >
        <div className={styles.toggleThumb}></div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
